import { Component } from '@angular/core';

import { SuburbCatalogueService } from '../workspace/catalogue.service';
import { SubRegionsService } from '../workspace/subregions.service';
import { WorkspaceStateService } from '../workspace/workspace-state.service';
import { skippedText } from './suburb-facts';

/**
 * Fill from council areas (#260), in a sub-region's panel: tick councils (its members' start ticked; search for
 * others), Preview what would join, then Apply as one step that Cmd+Z undoes.
 */
@Component({
  selector: 'section[app-suburb-council-fill]',
  templateUrl: './suburb-council-fill.component.html',
  styleUrls: ['./suburb-council-fill.component.scss'],
})
export class SuburbCouncilFillComponent {
  constructor(
    public state: WorkspaceStateService,
    public catalogue: SuburbCatalogueService,
    public subRegions: SubRegionsService
  ) {}

  /** The sub-region's region, which unassigned suburbs can go into. */
  get regionName(): string {
    return this.catalogue.regionName(this.subRegions.detail?.regionId);
  }

  skipped(): string {
    const fp = this.subRegions.fillPreview;
    return fp ? skippedText(fp, (id) => this.catalogue.regionName(id)) : '';
  }
}
